import chevronLeftLargeToken from "@amzn/meridian-tokens/base/icon/chevron-left-large";
import chevronRightLargeToken from "@amzn/meridian-tokens/base/icon/chevron-right-large";
import Button from "@amzn/meridian/button";
import Column from "@amzn/meridian/column";
import Icon from "@amzn/meridian/icon";
import Loader from "@amzn/meridian/loader";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import React from "react";
import { getGroundTruthDataReviewStatus } from "src/components/shared/groundTruth/reviewTable/helpers";
import { ReviewStatus, setMoveToNextWhenSave } from "src/store/modelLifeCycleGroundTruthSlice";
import { useAppDispatch, useAppSelector } from "src/store/store";
import Toggle from "@amzn/meridian/toggle";

interface ReviewHeaderProps {
  onLeftChevronClick?: () => void;
  onRightChevronClick?: () => void;
  onSaveClick: () => void;
  showMoveToNextToggle: boolean;
}
const ReviewHeader = ({
  onLeftChevronClick,
  onRightChevronClick,
  onSaveClick,
  showMoveToNextToggle,
}: ReviewHeaderProps) => {
  const { alias } = useAppSelector((state) => state.user);
  const { selectedGroundTruthData, updateGroundTruthDataLoading, moveToNextWhenSave } =
    useAppSelector((state) => state.modelLifeCycleGroundTruthSlice);
  const dispatch = useAppDispatch();

  return (
    <Row widths={["70%", "30%"]}>
      <Row spacing={"400"}>
        {onLeftChevronClick && (
          <div onClick={onLeftChevronClick}>
            <Column spacingInset={"300"} className="icon">
              <Icon tokens={chevronLeftLargeToken} />
            </Column>
          </div>
        )}
        {onRightChevronClick && (
          <div onClick={onRightChevronClick}>
            <Column spacingInset={"300"} className="icon">
              <Icon tokens={chevronRightLargeToken} />
            </Column>
          </div>
        )}
        <Text type="h500">
          <p className="weight">Source ID: {selectedGroundTruthData.sourceId}</p>
        </Text>
        <Text>
          <p className="weight">
            Status: {getGroundTruthDataReviewStatus(selectedGroundTruthData, alias)}
          </p>
        </Text>

        {selectedGroundTruthData.metadata?.siteCode && (
          <Text>
            <p className="weight">Site: {selectedGroundTruthData.metadata?.siteCode}</p>
          </Text>
        )}
        {selectedGroundTruthData.status === ReviewStatus.REVIEWED && (
          <Text>
            <p className="weight">Reviewed by: {selectedGroundTruthData.reviewer}</p>
          </Text>
        )}
      </Row>
      <Row alignmentHorizontal="end">
        <Row widths={"fill"} alignmentHorizontal="center">
          <Column spacing={"100"} spacingInset={"100"}>
            {updateGroundTruthDataLoading === "pending" ? (
              <Button size="large">
                <Loader size={"small"} />
              </Button>
            ) : (
              <Button size="large" onClick={onSaveClick} data-cy={"save-and-next__button"}>
                {moveToNextWhenSave ? "Save & Next" : "Save"}
              </Button>
            )}
            {showMoveToNextToggle && (
              <Toggle
                checked={moveToNextWhenSave}
                onChange={() => dispatch(setMoveToNextWhenSave(!moveToNextWhenSave))}
                size="small"
              >
                Navigate to next unreviewed case
              </Toggle>
            )}
          </Column>
        </Row>
      </Row>
    </Row>
  );
};

export default ReviewHeader;
